const footer = {
  copyright: 'Pegasus Arms LLC. All rights reserved.',
  terms: {
    text: `Copying, distributing, or any other use of the materials on this website is prohibited without the written consent of the copyright holder. 
    By using this website, you agree to `,
    and: ' and ',
    links: {
      terms: 'the Terms of Use',
      privacy: 'the Privacy Policy.',
    },
  },
}

export default footer
